function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M3.1081 16.9999L0.5 15.5912L7.00678 8.64775L0.500485 1.4088L3.1086 0L10.0496 7.94334C10.2669 8.34585 10.2669 8.84901 10.0496 9.35216L3.1081 16.9999Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMSAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiIGQ9Ik0zLjEwODEgMTYuOTk5OUwwLjUgMTUuNTkxMkw3LjAwNjc4IDguNjQ3NzVMMC41MDA0ODUgMS40MDg4TDMuMTA4NiAwTDEwLjA0OTYgNy45NDMzNEMxMC4yNjY5IDguMzQ1ODUgMTAuMjY2OSA4Ljg0OTAxIDEwLjA0OTYgOS4zNTIxNkwzLjEwODEgMTYuOTk5OVoiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg==";
export { SvgComponent as ReactComponent };